import { Web3 } from 'web3';

export const weiToEthWithDecimals = (wei: string, decimals: number): string => {
    try {
        return parseFloat(Web3.utils.fromWei(wei, 'ether')).toFixed(decimals);
    } catch (e) {
        return wei;
    }
}